/**
 *  default prefix "FILTER_PANEL_"
 */

export const AT_FILTER_PANEL_ACTION_SET = 'FILTER_PANEL_FILTERS_PANEL_ACTION_SET';
export const AT_FILTER_PANEL_SET = 'FILTER_PANEL_FILTERS_PANEL_SET';
